export default __webpack_public_path__ + "static/media/bitpointer.e9c98ae3.svg";